import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_DISTANCE_REQUEST} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const DistanceRequest = lazy(() =>
  import('../../../screens/DistanceRequest')
    .then(module => ({default: module.DistancesRequest})));

const DistanceRequestNavigation = [
  {
    path: ROUTE_DISTANCE_REQUEST,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DistanceRequest />
      </Suspense>
    ),
  },
];

export default DistanceRequestNavigation;
